import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=2c503732&lang=pug"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=2c503732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports